/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

import http from "../http-common";

const controller = "/informationImages";
const informationImagesService = {
    getInstallImages: async (partnerOrgId, customerOrgId) => {
        const response = await http.get(`${controller}/installs/${partnerOrgId}/${customerOrgId}`);
        return response.data;
    }
}

export default informationImagesService;